export interface PalletScanLabelConfig {
  scanMode: "auto" | "manual";
  autoPrintCartonLabel: boolean;
  autoPrintPalletLabel: boolean;
}

export const DefaultPalletScanLabelConfig: PalletScanLabelConfig = {
  scanMode: "auto",
  autoPrintCartonLabel: true,
  autoPrintPalletLabel: true,
};
